/* global ywcas_search_results_block_parameter */
import React from 'react';
import parse from 'html-react-parser';
import {useState} from '@wordpress/element';
import {Stack, Typography, Spinner, Box} from '@lapilli-ui/components';
import {Button} from '@wordpress/components';

import {isEmpty} from '../../utils/functions';
import ItemThumb from './item-thumb';

function ResultItem(props) {
  const {
    item, searchQuery, onClick, showName, showImage, layout, imageSize, productNameColor, results,
  } = props;

  const stackDirection = 'row';
  const stackAlign = 'center';
  const marginLeft = 0;


  const ItemName = () => {
    if (!showImage && isEmpty(item.thumbnail)) {
      return '';
    }
    return (
        <Stack className="search-result-item_name" sx={{flex: 1, alignItems: 'left'}} onClick={(e) => onClick(e, item, results.totalResults)}>
          {showName && <Typography sx={{color: productNameColor, fontSize: '0.9em'}} className="search-result-item__name" >{parse(item.name)}</Typography>}
        </Stack>
    );
  };

  return (
      <Box className={`search-result-item list`}>
      <Stack align={stackAlign} direction={stackDirection} spacing={2} className={`search-result-item__content`} data-id={item.post_id} data-name={item.name} onClick={(e) => onClick(e, item)}>
        {showImage  && <ItemThumb marginLeft={marginLeft} item={item} {...props}/>}
        <ItemName/>
      </Stack>
      </Box>
  );
}

export default ResultItem;